import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCallback, useEffect, useRef } from 'react';
import { useHistory } from 'quartz-routing/react-router';
import { usePortalsAuth, HubSpotForm, getPortalEnv, getPortalHublet } from 'portals-platform-lib';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export function TicketCreation({
  onSuccess,
  formGuid,
  portalData
}) {
  var _getPortalEnv;
  const {
    user
  } = usePortalsAuth();
  const history = useHistory();
  const email = user === null || user === void 0 ? void 0 : user.email;
  const originalParamsRef = useRef(null);
  useEffect(() => {
    if (!originalParamsRef.current) {
      originalParamsRef.current = new URLSearchParams(window.location.search);
    }

    //TODO: Replace with a way to directly pass email down to PP
    const params = new URLSearchParams();
    if (email) {
      params.set('email', email);
    }
    history.replace({
      search: params.toString()
    });
    return () => {
      var _originalParamsRef$cu;
      return history.replace({
        search: (_originalParamsRef$cu = originalParamsRef.current) === null || _originalParamsRef$cu === void 0 ? void 0 : _originalParamsRef$cu.toString()
      });
    };
  }, [email, history]);
  const onFormSubmitted = useCallback(() => {
    FloatingAlertStore.addAlert({
      message: I18n.text('customer-portal-app.ticketSubmittedAlert.message'),
      titleText: I18n.text('customer-portal-app.ticketSubmittedAlert.title'),
      type: 'success'
    });
    onSuccess();
  }, [onSuccess]);
  return /*#__PURE__*/_jsx(HubSpotForm, {
    formId: formGuid,
    portalId: String(portalData.portalId),
    env: (_getPortalEnv = getPortalEnv()) !== null && _getPortalEnv !== void 0 ? _getPortalEnv : '',
    region: getPortalHublet(),
    onFormSubmitted: onFormSubmitted,
    loadingFallback: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "400",
      "aria-label": I18n.text('customer-portal-app.loading')
    })
  });
}